import { CognitoIdToken } from "@goodfill/backend-api-client";
import { BrokerRecognizedEmployer } from "@goodfill/domain-customer-application-types";

export type EmployeeTracksList = {
  employeeTracks: Array<BrokerRecognizedEmployer>;
};

export const listEmployeeTracks = async (cognitoIdToken?: CognitoIdToken): Promise<EmployeeTracksList> => {
  const result = await fetch(
    `${import.meta.env.VITE_BACKEND_BASE_URL}/customer-application/listBrokerEnumerations/employeeTracks`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${cognitoIdToken}`,
      },
    },
  );
  return result.json();
};
